const TOKEN = '@gtech_token';
const TOKEN_EXPIRED = '@gtech_token_expired';
const USER_DATA = '@gtech_user_data';
const EXPIRE_TIME = '@gtech_token_expire_time';
const BROWSER_ID = '@gtech_browser_id';
const BROWSER_ID_EXPIRED = '@gtech_browser_id_expired';
const LANGUAGE = '@gtech_default_language';

export const clearStorage = () => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(TOKEN_EXPIRED);
  localStorage.removeItem(USER_DATA);
  localStorage.removeItem(EXPIRE_TIME);
  localStorage.removeItem(LANGUAGE);
};

export function setDefaultLang(value) {
  localStorage.setItem(LANGUAGE, value);
}

export function getDefaultLang() {
  return localStorage.getItem(LANGUAGE);
}

export function setBrowserId(value) {
  localStorage.setItem(BROWSER_ID, value);
}

export function getBrowserId() {
  return localStorage.getItem(BROWSER_ID);
}

export function setBrowserIdExpired(value) {
  localStorage.setItem(BROWSER_ID_EXPIRED, value);
}

export function getBrowserIdExpired() {
  return localStorage.getItem(BROWSER_ID_EXPIRED);
}

export function setToken(value) {
  localStorage.setItem(TOKEN, value);
}

export function getToken() {
  return localStorage.getItem(TOKEN);
}

export function setExpireTime(value) {
  localStorage.setItem(EXPIRE_TIME, value);
}

export function setUserData(value) {
  localStorage.setItem(USER_DATA, JSON.stringify(value));
}

export function getUserData() {
  const retval = localStorage.getItem(USER_DATA);

  return JSON.parse(retval) || '';
}

export function checkExpireToken() {
  const time = new Date().getTime();
  const expire = localStorage.getItem(EXPIRE_TIME) || 0;
  return time > expire;
}

export function wannaExpire() {
  const time = new Date().getTime();
  const expire = localStorage.getItem(EXPIRE_TIME) || 0;
  const timeLeft = expire - time;
  return getToken() && timeLeft < 120000 && timeLeft > 0;
}

export function addDays(first = new Date(), second = 0) {
  return first.setDate(first.getDate() + second);
}
